import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Provider,
  Flex,
  Input,
  Button,
  Divider,
  List,
  Avatar,
  Checkbox,
  Popup,
} from "@fluentui/react-northstar";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import { ChevronStartIcon } from "@fluentui/react-icons-northstar";
import Slider from "../common/slider";
import { useSelector, useDispatch } from "react-redux";
import ButtonComponent from "../common/button";
import _ from "lodash";
import {
  savesingleUserPoints,
  checkBoxSelectionforRecipient,
  setPointsforEachUser,
  addPointsForCustomUser,
} from "../../action/actionCreators";
import TextContent from "../common/Text";
import { motion, AnimatePresence } from "framer-motion";
import { pageVariants } from "../common/utils";
import { ChevronDownIcon } from "@fluentui/react-icons-northstar";
import { useTranslation } from "react-i18next";
import { TooltipHost, ITooltipHostStyles } from "@fluentui/react/lib/Tooltip";

export const AddPointsToRecipents = (props) => {
  const [{ inTeams, theme }] = useTeams();
  const [downUpIcons, setUpDownIcon] = useState(false);
  const location = useLocation();
  const promotion = useSelector((state: any) => state.commonReducer.promotion);
  const numberPoints = useSelector((state: any) => state.commonReducer);
  const [currentValue, setSliderCurrentValue] = useState(Number);
  const recipients = useSelector(
    (state: any) => state.commonReducer.recepients
  );
  const [points, setPoints] = useState(0);
  const [showMultiRecipients, setMultiRecipients] = useState(
    numberPoints.checked ? numberPoints.checked : false
  );
  const [multiTextBox, setMultiTextBox] = useState(
    _.size(numberPoints.customPoints) ? numberPoints.customPoints : {}
  );
  const [singleText, setSingleText] = useState(
    numberPoints?.numberObj?.points ? numberPoints?.numberObj?.points : ""
  );
  const [multiRecipient, setmultiRecipient] = useState(
    numberPoints.singleMultiUserPoints.length > 0 ? recipients : recipients
  );
  const [multiTextValidate, setmultiTextValidate] = useState({});
  const [totalPoints, setSelectedPoints] = useState({});
  const [multiDataCount, setMultiDataCount] = useState([]);
  const [optInType, setOptInType] = useState("");
  const [PointsRemainingError, setPointsRemainingError] = useState("");
  const [valuecheck, setValuecheck] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const showList = () => {
    setUpDownIcon(!downUpIcons);
  };
  const { t, i18n } = useTranslation();
  const exceptThisSymbols = ["e", "E", "+", "-", "."];

  useEffect(() => {
    if (currentValue <= -1) {
      setPointsRemainingError("Over Budget, please reduce point usage");
    }
    else {
      setPointsRemainingError("");
    }
  }, [currentValue]);

  const onPointsChanges = (e, details) => {

    const { value, name } = details;
    if (!promotion.awardFixed) {
      if (value.includes(".")) {
        return false;
      }

    }
    setSingleText(value);
    const recipientOptout = recipients.filter(
      (val) => val.optOutAwards === false
    );
    // tslint:disable: no-shadowed-variable
    const totalPoints =
      recipientOptout.length > 0
        // tslint:disable: no-shadowed-variable
        ? _.sumBy(recipientOptout, (e) => Math.round(value * e.countryRatio))
        : 0;
    const budgetPoints = promotion?.budgetInfo?.currentValue;
    const reminingPoints = budgetPoints - totalPoints;
    setSliderCurrentValue(reminingPoints);
  };

  const onSinglePointBlur = (e) => {
    const { value } = e.target;
    const budgetPoints = promotion?.budgetInfo?.currentValue;
    // tslint:disable: no-shadowed-variable
    const totalPoints =
      recipients.length > 0
        // tslint:disable: no-shadowed-variable
        ? _.sumBy(recipients, (e) => Math.round(value * e.countryRatio))
        : 0;
    const reminingPoints = budgetPoints - totalPoints;
    const values = {
      points: parseInt(value),
      pointasPerHeadCount: totalPoints,
      remainingPoints: reminingPoints,
    };
    setSelectedPoints(totalPoints);
    dispatch(savesingleUserPoints(values));
  };

  const onMultiTextBoxChange = (e, data) => {
    if (!e.target.value) {
      setValuecheck(false);
    }
    else {
      setValuecheck(true);
    }
    const { name, value } = data;
    if (value && value.includes(".")) {
      return false;
    }
    setMultiTextBox({
      ...multiTextBox,
      [name]: value,
    });
  };

  const onMultiTextBoxBlurChanges = (e) => {
    const { name, value } = e.target;
    setmultiTextValidate({
      ...multiTextValidate,
      [name]: parseInt(value),
      [`${name}_error`]: _.inRange(
        multiTextBox[name],
        promotion.awardMin,
        promotion.awardMax
      ),
    });
  };

  useEffect(() => {
    const multiTextValues = _.values(multiTextBox);
    setMultiDataCount(multiTextValues.filter((item) => item));
    const objLength = Object.keys(multiTextBox).length;
    const budgetSum = _.sumBy(
      recipients.filter((val) => val.optOutAwards === false),
      (e) =>
        Math.round(
          (multiTextBox[e.key] ? multiTextBox[e.key] : 0) * e.countryRatio
        )
    );
    if (objLength > 0) {
      // tslint:disable: no-shadowed-variable
      const totalPoints = promotion?.budgetInfo?.currentValue;
      const values = Object.values(multiTextBox);
      const realNumbers = values.map((i) => Number(i));
      const sum = _.sum(realNumbers);
      setSelectedPoints(sum);
      const point = totalPoints - budgetSum;
      setSliderCurrentValue(point);
    }
  }, [multiTextBox]);

  const inRangeOrnot = (arr, min, max) => {
    const range = arr.map((val) => {
      return parseInt(val) >= min && parseInt(val) <= max;
    });
    return range;
  };

  useEffect(() => {
    setSliderCurrentValue(
      numberPoints.checked
        ? _.size(multiTextBox) > 0
          ? promotion?.budgetInfo?.currentValue - numberPoints.sum
          : promotion?.budgetInfo?.currentValue
        : _.size(numberPoints.numberObj) > 0
          ? promotion?.budgetInfo?.currentValue -
          _.sumBy(recipients, (e) =>
            Math.round(
              numberPoints.numberObj.points ? numberPoints.numberObj.points : 0 * e.countryRatio
            )
          )
          : promotion?.budgetInfo?.currentValue
    );
    if (numberPoints.checked) {
      //const multiTextValues = _.map(number.singleMultiUserPoints, "value");
      const commonValues = numberPoints.singleMultiUserPoints.filter((o1) =>
        numberPoints.recepients.some((o2) => o1.key === o2.key)
      );
      const obj = {};
      if (numberPoints.promotion.budgetInfo == null && numberPoints.promotion.awardFixed) {
        for (const x in numberPoints.recepients) {
          obj[numberPoints.recepients[x].key] = numberPoints.promotion.awardFixed;
        }
      }
      else {
        for (const x in commonValues) {
          obj[commonValues[x].key] = commonValues[x].value;
        }
      }
      setMultiTextBox(obj);
      const multiTextValues = _.map(commonValues, "value");
      setMultiDataCount(multiTextValues.filter((item) => item));
    }
    if (promotion.awardFixed) {
      setSingleText(promotion.awardFixed);
      const details = {
        value: promotion.awardFixed,
      };
      onPointsChanges("", details);
    }
    if (checkForOpt() === "partial" || checkForOpt() === "all") {
      onCheckBoxChange({}, { checked: true });
    }
    setOptInType(checkForOpt());
  }, []);

  const listDataConversion = (data) => {
    const result = data.map((val) => {
      return {
        key: val.text,
        media: <Avatar name={val.text} />,
        header: (
          <TextContent className="bit_text_17 paxName" content={val.text} />
        ),
        content: (
          <TextContent
            className="bit_text_14 paxDetail"
            content={val.tertiaryText}
          />
        ),
      };
    });
    return result;
  };
  // tslint:disable: no-shadowed-variable
  const addpointsToMutiRecipients = (recipients, customData) => {

    const result = recipients.map((val) => {
      return {
        ...val,
        value: val.optOutAwards ? 0 : customData[val.key],
        budgetPoints: Math.round(
          (val.optOutAwards ? 0 : customData[val.key]) * val.countryRatio
        ),
        multiManual: true,
        totalPoints,
      };
    });
    return result;
  };
  // tslint:disable: no-shadowed-variable
  const addpointsToSingleRecipients = (recipients, value) => {
    const result = recipients.map((val) => {
      return {
        ...val,
        value: val.optOutAwards ? 0 : value,
        budgetPoints: Math.round(
          (val.optOutAwards ? 0 : value) * val.countryRatio
        ),
        single: true,
        totalPoints,
      };
    });
    return result;
  };

  const gotoAddBehaviour = () => {
    let recepientList;
    if (numberPoints.checked) {
      recepientList = addpointsToMutiRecipients(recipients, multiTextBox);
    } else {
      recepientList = addpointsToSingleRecipients(recipients, singleText);
    }
    dispatch(setPointsforEachUser(recepientList));
    dispatch(addPointsForCustomUser(multiTextBox));
    history.push({
      pathname: "/addbehaviours",
    });
  };

  const goBack = () => {
    let recepientList;
    if (numberPoints.checked) {
      recepientList = addpointsToMutiRecipients(recipients, multiTextBox);
    } else {
      recepientList = addpointsToSingleRecipients(recipients, singleText);
    }
    dispatch(setPointsforEachUser(recepientList));
    dispatch(addPointsForCustomUser(multiTextBox));
    history.push({
      pathname: "/search/:token",
    });
  };

  const listDataForMultiList = (data) => {
    const result = data.map((val) => {
      return {
        id: val.id,
        key: val.text,
        media: <Avatar name={val.text} image={val.imageUrl && val.imageUrl} />,
        header: (
          <div className="bit_list_grid">
            <TextContent className="bit_text_17 paxName" content={val.text} />
            <TextContent
              className="bit_text_14 paxDetail"
              content={val.tertiaryText}
            />
          </div>
        ),
        headerMedia: (
          <div>
            <Flex.Item>
              <Flex>
                <Flex.Item>
                  {val.optOutAwards ? (
                    <TooltipHost
                      content={`${t("PointsPage.OptedOut")}`}
                      id={"tooltipId0"}
                      calloutProps={{ gapSpace: 0 }}
                      styles={hostStyles}
                    >
                      <Input
                        className="bit_input_box_small bit_input_box"
                        onChange={(e, value) => onMultiTextBoxChange(e, value)}
                        onBlur={(e) => onMultiTextBoxBlurChanges(e)}
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) && e.preventDefault()
                        }
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        placeholder="0"
                        type="number"
                        name={val.key}
                        value={val.optOutAwards ? 0 : multiTextBox[val.key]}
                        error={
                          !val.optOutAwards &&
                            multiTextValidate[val.key] >= promotion.awardMin &&
                            !val.optOutAwards &&
                            multiTextValidate[val.key] <= promotion.awardMax
                            ? false
                            : multiTextValidate[val.key] > 0 &&
                            !promotion.awardFixed &&
                            true
                        }
                        disabled={
                          (promotion.awardFixed && true) || val.optOutAwards
                        }
                      />
                    </TooltipHost>
                  ) : (
                    <Input
                      className="bit_input_box_small bit_input_box"
                      onChange={(e, value) => onMultiTextBoxChange(e, value)}
                      onBlur={(e) => onMultiTextBoxBlurChanges(e)}
                      onKeyDown={(e) =>
                        exceptThisSymbols.includes(e.key) && e.preventDefault()
                      }
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      placeholder="0"
                      type="number"
                      name={val.key}
                      value={multiTextBox[val.key]}
                      error={
                        multiTextValidate[val.key] >= promotion.awardMin &&
                          multiTextValidate[val.key] <= promotion.awardMax
                          ? false
                          : multiTextValidate[val.key] > 0 &&
                          !promotion.awardFixed &&
                          true
                      }
                      disabled={promotion.awardFixed && true}
                    />
                  )}
                </Flex.Item>
                <ButtonComponent content={`${t("PointsPage.Points")}`} />
              </Flex>
            </Flex.Item>
            {_.inRange(
              multiTextValidate[val.key],
              promotion.awardMin,
              promotion.awardMax + 1
            )
              ? null
              : multiTextValidate[val.key] > 0 &&
              !promotion.awardFixed && (
                <div className="bit_pos_rel white-no-wrap">
                  <TextContent
                    content={`${t("PointsPage.CustomText")}`}
                    className="error-message bit_pos_abs"
                  />
                </div>
              )}
          </div>
        ),
      };
    });
    return result;
  };

  const onCheckBoxChange = (e, value) => {
    const sum = _.sum(_.values(multiTextBox).map((i) => Number(i)));
    const { checked } = value;
    dispatch(checkBoxSelectionforRecipient(checked));
    setMultiRecipients(checked);
    setSliderCurrentValue(
      checked
        ? _.size(multiTextBox) > 0
          ? promotion?.budgetInfo?.currentValue - sum
          : promotion?.budgetInfo?.currentValue
        : _.size(numberPoints.numberObj) > 0
          ? numberPoints?.numberObj?.remainingPoints
          : promotion?.budgetInfo?.currentValue
    );
    // if condition code for dynamic input value populating in multitext box from single input box.
    if (numberPoints && numberPoints.numberObj && numberPoints.numberObj.points) {
      const obj = {};
      recipients.map((val) => {
        obj[val.key] = numberPoints.numberObj.points;
      });
      setMultiTextBox(obj);
    }
    if (promotion.awardFixed) {
      const multiData = _.reduce(
        recipients,
        (acc, { key }) => ({ ...acc, [key]: promotion.awardFixed }),
        {}
      );
      setMultiTextBox(multiData);
    }
  };

  const checkForOpt = () => {
    const count = recipients.filter((val) => val.optOutAwards === false).length;
    return count === recipients.length
      ? "none"
      : count === 0
        ? "all"
        : "partial";
  };

  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "flex", justifyContent: "flex-end" },
  };

  return (
    <motion.div initial="out" animate="in" exit="out" variants={pageVariants}>
      <Provider
        theme={theme}
        className="addPointsProvider recognitionPage appProvider mg-top-2rem"
      >
        <Divider />
        <div className="recepientsDropdown">
          <Flex vAlign="start" gap="gap.small">
            <Popup
              open={downUpIcons}
              onOpenChange={showList}
              trigger={
                <Button
                  title={
                    recipients.length === 1
                      ? `${t("PointsPage.Recipient")}`
                      : `${t("PointsPage.Recipients")}`
                  }
                  content={
                    recipients.length === 1
                      ? `${t("PointsPage.Recipient")}`
                      : `${t("PointsPage.Recipients")}`
                  }
                  iconPosition="after"
                  secondary
                  className="bs-none bd-none"
                  icon={<ChevronDownIcon xSpacing="after" />}
                />
              }
              content={
                <>
                  <Flex space="between">
                    <TextContent
                      content={
                        recipients.length === 1
                          ? `${recipients.length} ${t(
                            "Participants.Recipient"
                          )}`
                          : `${recipients.length} ${t(
                            "Participants.Recipients"
                          )}`
                      }
                      weight="regular"
                    />
                    <Flex gap="gap.smaller">
                      <Button
                        size="medium"
                        content={t("PointsPage.Edit")}
                        onClick={goBack}
                      />
                    </Flex>
                  </Flex>
                  <List
                    items={listDataConversion(recipients)}
                    styles={{ width: "100%" }}
                  />
                </>
              }
              position="below"
              align="center"
              className="mg-l-5 mg-r-5"
            />
          </Flex>
        </div>
        <Divider className="dropdownSeparator" />
        <div className="mg-l-5 mg-r-5">
          <Slider
            title={
              <TextContent
                className="bit_text_18"
                content={t("PointsPage.Header")}
                weight="bold"
              />
            }
            defaultValue={currentValue ? { currentValue } : null}
            max={promotion?.budgetInfo?.originalValue}
            custom={true}
            customText={
              <TextContent
                className="bit_text_12 bit_slider_text"
                content={`${currentValue?.toLocaleString()} ${t(
                  "PointsPage.PointsRemaining"
                )}`}
              />
            }
          />
          <div >
            <TextContent
              content={`${PointsRemainingError}`}
              className="error-message"
            />
          </div>
        </div>
        <div className="pd-bt-100p">
          <div className="mg-l-5 bit_space_space10">
            {promotion.awardFixed ? (
              <Checkbox
                label={
                  <TextContent
                    content={t("PointsPage.SubHeader") + "."}
                    weight="semibold"
                  />
                }
                checked={true}
                disabled={promotion.awardFixed && true}
              />
            ) : (
              <Checkbox
                label={
                  <TextContent
                    content={t("PointsPage.SubHeader") + "."}
                    weight="semibold"
                  />
                }
                onClick={onCheckBoxChange}
                checked={showMultiRecipients}
                disabled={optInType === "all" || PointsRemainingError !== ""}
              />
            )}
            {!showMultiRecipients && (
              <div className="mg-t-5p">
                <Flex.Item>
                  <Flex>
                    <Flex.Item>
                      <Input
                        className="bit_input_box_small bit_input_box"
                        onChange={(e, value) => onPointsChanges(e, value)}
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onBlur={(e) => onSinglePointBlur(e)}
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) && e.preventDefault()
                        }
                        placeholder="0"
                        type="number"
                        name="singleText"
                        value={singleText}
                        error={
                          numberPoints?.numberObj?.points >= promotion.awardMin &&
                            numberPoints?.numberObj?.points <= promotion.awardMax
                            ? false
                            : numberPoints?.numberObj?.points &&
                            !promotion.awardFixed &&
                            true
                        }
                        disabled={
                          (promotion.awardFixed && true) || optInType === "all"
                        }
                      />
                    </Flex.Item>
                    <ButtonComponent content={`${t("PointsPage.Points")}`} />
                  </Flex>
                </Flex.Item>
                {numberPoints?.numberObj?.points
                  ? _.inRange(
                    numberPoints?.numberObj?.points,
                    promotion.awardMin,
                    promotion.awardMax + 1
                  )
                    ? null
                    : numberPoints.numberObj.points &&
                    !promotion.awardFixed && (
                      <TextContent
                        content={`${t("PointsPage.CustomText")}`}
                        className="error-message"
                      />
                    )
                  : null}
                {!promotion.awardFixed && (
                  <div className="mg-t-5p mg-b-5p">
                    <TextContent
                      className="bit_text_14 bit_tinyText"
                      content={`${t("PointsPage.ValidationText")} ${promotion.awardMin
                        } ${t("PointsPage.And")} ${promotion.awardMax}`}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          {showMultiRecipients && (
            <>
              {!promotion.awardFixed && (
                <div className="mg-t-5p mg-b-5p mg-l-5">
                  <TextContent
                    className="bit_text_14 bit_tinyText"
                    content={`${t("PointsPage.ValidationText")} ${promotion.awardMin
                      } ${t("PointsPage.And")} ${promotion.awardMax
                      } for each recipient`}
                  />
                </div>
              )}
              <div className="mg-t-5p mg-l-5 multiuserlist">
                <List
                  className="bit_paxlist_space"
                  items={listDataForMultiList(multiRecipient)}
                />
              </div>
            </>
          )}
          <div className="footer">
            <Flex space="between">
              <Button
                icon={<ChevronStartIcon size="large" />}
                tinted
                iconOnly
                title={t("PointsPage.Back")}
                content={t("PointsPage.Back")}
                onClick={goBack}
                className="mg-l-5 bit-pad-10"
                style={{ border: "1px #6264a7 solid" }}
                size="medium"
              />
              {numberPoints.checked ? (
                <Flex gap="gap.smaller" className="mg-r-5 test1">
                  <Button
                    primary
                    size="medium"
                    title={t("PointsPage.SaveAwards")}
                    content={t("PointsPage.SaveAwards")}
                    onClick={gotoAddBehaviour}
                    disabled={
                      ((_.countBy(
                        inRangeOrnot(
                          multiDataCount,
                          promotion.awardMin,
                          promotion.awardMax
                        )
                      )[true] ===
                        recipients.filter((val) => val.optOutAwards === false)
                          .length && valuecheck) || optInType === "all" ||
                        promotion.awardFixed != null ||
                        (recipients.filter((val) => val.optOutAwards === true).length && numberPoints?.numberObj?.points)) && PointsRemainingError === ""
                        ? false
                        : true
                    }
                  />
                </Flex>
              ) : (
                <Flex gap="gap.smaller" className="mg-r-5 test2">
                  <Button
                    primary
                    size="medium"
                    content={`${t("PointsPage.SaveAwards")}`}
                    onClick={gotoAddBehaviour}
                    disabled={
                      ((singleText > 0 &&
                        numberPoints.numberObj.points >= promotion.awardMin &&
                        numberPoints.numberObj.points <= promotion.awardMax) ||
                        (numberPoints.numberObj.points > 0 &&
                          numberPoints.numberObj.points >= promotion.awardMin &&
                          numberPoints.numberObj.points <= promotion.awardMax) ||
                        promotion?.awardFixed != null ||
                        optInType === "all") && PointsRemainingError === ""
                        ? false
                        : true
                    }
                  />
                </Flex>
              )}
            </Flex>
          </div>
        </div>
      </Provider>
    </motion.div>
  );
};
